import React from "react";

export const CourseTaskDocs = ({
  index,
  taskContents,
  contentType,
  fileURL,
  setPdfFilePath,
}) => {
  const pdfContentType = 0;
  let lastElemt = index + 1 === taskContents.length;
  if (contentType === pdfContentType) {
    var dirArray = fileURL.split("/");
    let dir = dirArray[dirArray.length - 2];
    let fileNames = dirArray[dirArray.length - 1];
    let filePath = `${dir}/${fileNames}`;
    if (setPdfFilePath) {
      setPdfFilePath(filePath);
    }
    return (
      <div className={`course-view-div ${lastElemt && "mb-5"}`}>
        <iframe
          title="title_1"
          className="w-100"
          style={{ height: "100dvh" }}
          src={`/contents/${filePath}`}
        />
      </div>
    );
  } else {
    return (
      <div className={`course-view-div ${lastElemt && "mb-5"}`}>
        <iframe
          title="title_2"
          className="w-100"
          style={{ height: "100dvh" }}
          src={fileURL}
        />
      </div>
    );
  }
};
